import { isNil } from 'ramda';
import React from 'react';
import Icon from '~/components/atom/Icon';
import useTooltipLayer from '~/hooks/useTooltipLayer';

const ErrorsColumn: React.FC<{
  errorMessage: string | null;
}> = ({ errorMessage }) => {
  const tooltipProps = useTooltipLayer({
    tooltipMessage: errorMessage,
  });

  if (isNil(errorMessage)) return null;

  return (
    <Icon
      {...tooltipProps}
      strokeWidth={2.2}
      name="exclamation"
      color={{ group: 'danger' }}
    />
  );
};

export default ErrorsColumn;
